import { render, staticRenderFns } from "./uc-menu-sub.vue?vue&type=template&id=f5814166&scoped=true"
import script from "./uc-menu-sub.vue?vue&type=script&lang=ts"
export * from "./uc-menu-sub.vue?vue&type=script&lang=ts"
import style0 from "./uc-menu-sub.vue?vue&type=style&index=0&id=f5814166&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5814166",
  null
  
)

export default component.exports